import { setSmallScreenWarningModal } from "../store/general/slice";
import { useLocation } from "react-router-dom";
import { useDispatch } from "../store/store";
import { useEffect } from "react";

const useScreenWidthWarning = (routes: string[]) => {
  const location = useLocation();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const checkScreenWidth = () => {
  //     const isTargetRoute = routes.some(i => location.pathname.includes(i));
  //     dispatch(setSmallScreenWarningModal(window.innerWidth < 767 && isTargetRoute));
  //   };

  //   checkScreenWidth(); // Check on mount
  //   window.addEventListener("resize", checkScreenWidth);

  //   return () => window.removeEventListener("resize", checkScreenWidth);
  // }, [location.pathname]);
};

export default useScreenWidthWarning;
